import { useState } from "react";
import siteConfig from "site-config";

import { API_STATES, createAuthHeader } from "models/new/helpers";
import { TAPIResponse } from "models/new/types";
import { fetchJSON } from "lib/fetch";

export type TEnableMerchantPayload = {
    brandID: string;
    body: {
        credentials: {
            account_number?: string;
            username?: string;
            password?: string;
            api_key?: string;
        };
    };
};

export type TEnableMerchantError = { code: number; message: string };

export type TEnableMerchantResponse = {};

type TEnableMerchantHookParams = {};

type TEnableMerchantHookResponse<TEnableMerchantHookParams, Response> = {
    (params?: TEnableMerchantHookParams): Response & {
        enableMerchant: (params: TEnableMerchantPayload) => void;
    };
};

export const useEnableMerchant: TEnableMerchantHookResponse<
    TEnableMerchantHookParams,
    TAPIResponse<TEnableMerchantResponse, TEnableMerchantError>
> = (_params: TEnableMerchantHookParams) => {
    const [state, setState] = useState<TAPIResponse<TEnableMerchantResponse, TEnableMerchantError>>(API_STATES.default);
    const APIStates = API_STATES.getStates(setState);

    const enableMerchant = (params: TEnableMerchantPayload) => {
        const URL = `${siteConfig.api}/lightspeed-b2b/api/v1/merchant-enablement/brands/${params.brandID}`;

        APIStates.pending();

        fetchJSON<TEnableMerchantResponse>(URL, {
            method: "POST",
            body: JSON.stringify(params.body),
            headers: createAuthHeader({ bypassEnvironmentCheck: true }),
        })
            .then(APIStates.success)
            .catch((error) => APIStates.error({ message: error }));
    };

    return {
        data: state.data,
        error: state.error,
        isLoading: state.isLoading,
        loaded: state.loaded,
        enableMerchant,
    };
};
